<template>
  <PopUpContents
    ref="popup"
    height="40rem"
  >
    <!-- ------------ -->
    <!--  item   -->
    <!-- ------------ -->
    <div class="item-fluid p-3 m-2">
      <!-- ----------------- -->
      <!-- row 1 - title     -->
      <!-- ----------------- -->
      <div class="row h-40">
        <p class="bb-page-title mt-3 mb-2">{{ title }}</p>
      </div>
      <!-- ----------------- -->
      <!-- row 2 - subject   -->
      <!-- ----------------- -->
      <!-- <p class="bb-hdg mt-3 mb-3">{{ subject }}</p> -->
      <!-- ---------------------- -->
      <!--  row 3 - item/buttons  -->
      <!-- ---------------------- -->
      <div class="row mt-3 mb-3">
        <!-- ------- -->
        <!--  item   -->
        <!-- ------- -->
        <div class="col-7 form-group">
          <div class="form-floating">
            <input
              readonly
              class="form-control"
              :value="item.name"
              id="name"
              disabled
            />
            <label
              class="bb-float-label optional"
              for="name"
              >Item Name</label
            >
          </div>
        </div>
        <!-- ---------- -->
        <!--  buttons   -->
        <!-- ---------- -->
        <div class="col-5">
          <div
            class="btn-group special mt-4"
            role="group"
          >
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              v-if="cancelButton"
              type="button"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              {{ cancelButton }}
            </button>
            <!-- ------------ -->
            <!--      OK      -->
            <!-- ------------ -->
            <button
              v-if="okButton"
              type="button"
              @click="_confirm"
              class="btn btn-lg btn-primary"
            >
              {{ okButton }}
            </button>
          </div>
        </div>
      </div>
      <!-- ---------------------- -->
      <!--   row 3 - clear list   -->
      <!-- ---------------------- -->
      <div class="row mt-3 mb-3"></div>
      <div class="row mt-3 mb-3"></div>
      <p class="bb-hdg mt-3 mb-3">{{ message }}</p>
      <div class="row mt-3 mb-3">
        <div class="form-group">
          <div class="form-floating">
            <div
              class="form-control bb-linked-values-scroll clearList-dialog-select"
              id="item"
            >
              <div
                v-for="(value, idx) in clearList"
                :key="idx"
                class="bb-linked-values-item clearList-item"
              >
                {{ value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PopUpContents>
</template>

<script>
import PopUpContents from './PopUpContents.vue'

export default {
  name: 'ClearDialog',
  components: {
    PopUpContents,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    title: undefined,
    subject: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: undefined,
    rejectPromise: undefined,
    resolvePromise: undefined,
    item: {},
    clearList: [],
    adjustments: {},
  }),
  //=====================================================================
  // methods
  //---------
  methods: {
    //================================================================================
    // generic formatter for ENC-like numeric fields
    //-----------------------------------------------
    formatEnc(value) {
      if (value === null || value === undefined) return ''
      const num = typeof value === 'string' ? parseFloat(value) : value
      if (Number.isNaN(num)) return ''
      return num.toFixed(2)
    },
    normalizeId(value) {
      if (value === null || value === undefined || value === '') return null
      return String(value)
    },
    getLinkedCharacterItemId(entry) {
      if (!entry) {
        return null
      }

      const rawLinkedItem =
        entry.character_item ?? entry.character_item_id ?? entry.item_id ?? null

      if (
        rawLinkedItem === null ||
        rawLinkedItem === undefined ||
        rawLinkedItem === ''
      ) {
        return null
      }

      if (typeof rawLinkedItem === 'object') {
        return this.normalizeId(rawLinkedItem.id)
      }

      return this.normalizeId(rawLinkedItem)
    },
    formatSpellLabel(spell) {
      const label = spell?.display_name || spell?.name || 'Spell'
      const mag =
        spell?.mag !== undefined && spell?.mag !== null
          ? ` (Mag ${spell.mag})`
          : ''

      return `${label}${mag}`
    },
    appendReasonEntries(clearList, prefix, reasons) {
      if (!Array.isArray(clearList) || !prefix || !reasons) {
        return
      }

      reasons
        .split('. ')
        .map((entry) => entry.trim().replace(/[.]+$/u, ''))
        .filter((entry) => entry !== '')
        .forEach((entry) => {
          clearList.push(`${prefix}: ${entry}`)
        })
    },
    //================================================================================
    // show dialog
    //-------------
    show(opts = {}) {
      // passed in parms
      this.title = opts.title
      this.subject = opts.subject
      this.item = opts.item
      this.character = opts.character
      this.adjustments = opts.adjustments
      this.message = opts.message

      console.log('SHOW item =', this.item)
      console.log('SHOW character =', this.character)
      console.log('SHOW adjs =', this.adjustments)

      if (opts.okButton) {
        this.okButton = opts.okButton
      }
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      // load clear list for item (safe if list is empty)
      this.clearList = this.getClearList({
        item: this.item,
        character: this.character,
        adjustments: this.adjustments,
      })
      console.log('SHOW clearList=', this.clearList)

      // If there is nothing actually linked to clear (no container,
      // runes, spells, adjustments, etc.) then skip showing the
      // dialog entirely and immediately resolve as if the user
      // confirmed. This avoids an empty confirmation popup.
      if (!Array.isArray(this.clearList) || this.clearList.length === 0) {
        return Promise.resolve({ cancel: false })
      }

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    //================================================================================
    // get clear list
    //----------------
    getClearList({ item, character, adjustments }) {
      console.log('getClearList =', item)
      let clearList = []
      const allRunes = Array.isArray(character?.runes) ? character.runes : []
      const allSpells = Array.isArray(character?.spells) ? character.spells : []
      const itemId = this.normalizeId(item?.id)

      if (!item) {
        return []
      }
      console.log('item.container = ', item.container)
      // Note: we no longer show any container relationship here; when
      // an item is cleared or deleted, the container itself remains
      // and only the stored-in link is nulled silently.
      //----------------------------
      // worn_location
      //----------------------------
      // Character worn locations themselves are fixed as part of the
      // character; deleting an item only nulls the FK. We therefore do
      // not show a separate clearList entry for worn_location.
      //---------------------------------------------------
      // add entry if integrated runes (could be multiple)
      //---------------------------------------------------
      const item_runes_integrated = allRunes.filter((r) => {
        return (
          this.getLinkedCharacterItemId(r) === itemId && r.integrated == true
        )
      })
      if (item_runes_integrated.length > 0) {
        item_runes_integrated.forEach((rune) => {
          clearList.push(
            `Integrated Rune: ${rune.name} Strength (${rune.strength})`,
          )
        })
      }
      //-----------------------------------------------------
      // add entry if unintegrated runes (could be multiple)
      //-----------------------------------------------------
      const item_runes_unintegrated = allRunes.filter((r) => {
        return (
          this.getLinkedCharacterItemId(r) === itemId && r.integrated == false
        )
      })
      if (item_runes_unintegrated.length > 0) {
        item_runes_unintegrated.forEach((rune) => {
          clearList.push(
            `Unintegrated Rune: ${rune.name} Strength (${rune.strength})`,
          )
        })
      }
      //----------------------------------------------------------------
      // add entries for rune-linked spells that will be removed because
      // deleting this item removes the last rune(s) of a given name
      //----------------------------------------------------------------
      const linkedRunes = allRunes.filter(
        (r) => this.getLinkedCharacterItemId(r) === itemId,
      )

      if (linkedRunes.length > 0 && allSpells.length > 0) {
        const deletedRuneNames = [
          ...new Set(
            linkedRunes
              .map((r) => (r?.name || '').toString().trim())
              .filter((name) => name !== '')
              .filter((name) => {
                return !allRunes.some(
                  (candidate) =>
                    this.getLinkedCharacterItemId(candidate) !== itemId &&
                    (candidate?.name || '').toString().trim() === name,
                )
              }),
          ),
        ]

        if (deletedRuneNames.length > 0) {
          const runeSpellKeys = new Set()
          const linkedRuneSpells = allSpells.filter((spell) => {
            if (!spell) return false

            const sourceLabel = (spell.source || '').toString().toLowerCase()
            const spellRuneName = (spell.casting_rune_name || '')
              .toString()
              .trim()
            const spellRuneId = this.normalizeId(
              spell.character_rune ??
                spell.character_rune_id ??
                spell.source_id,
            )

            const matchesDeletedRuneName =
              spellRuneName !== '' && deletedRuneNames.includes(spellRuneName)
            const matchesDeletedRuneId = linkedRunes.some(
              (rune) => this.normalizeId(rune.id) === spellRuneId,
            )

            if (
              !(
                (sourceLabel === 'rune' || spell.character_rune != null) &&
                (matchesDeletedRuneName || matchesDeletedRuneId)
              )
            ) {
              return false
            }

            const dedupeKey = [
              this.normalizeId(
                spell.character_spell_id ??
                  spell.character_rune_spell_id ??
                  spell.character_item_spell_id ??
                  spell.id,
              ) || spell.name,
              spell.mag ?? '',
            ].join('|')

            if (runeSpellKeys.has(dedupeKey)) {
              return false
            }

            runeSpellKeys.add(dedupeKey)
            return true
          })

          linkedRuneSpells.forEach((spell) => {
            clearList.push(`Rune Spell: ${this.formatSpellLabel(spell)}`)
          })
        }
      }
      //---------------------------------------------
      // add entry for any item-granted spells
      //---------------------------------------------
      if (allSpells.length > 0 && item.id !== undefined && item.id !== null) {
        const item_spells = allSpells.filter((s) => {
          if (this.getLinkedCharacterItemId(s) !== itemId) {
            return false
          }

          const sourceLabel = (s?.source || '').toString().toLowerCase()
          const isRuneLinkedSpell =
            sourceLabel === 'rune' ||
            s?.character_rune != null ||
            s?.character_rune_id != null

          return !isRuneLinkedSpell
        })
        if (item_spells.length > 0) {
          item_spells.forEach((spell) => {
            const label =
              spell?.type === 'Sorcery'
                ? 'Item Spell & Casting Skill'
                : 'Item Spell'
            clearList.push(`${label}: ${this.formatSpellLabel(spell)}`)
          })
        }
      }
      //----------------------------------
      // add entry if characteristic adjs
      //----------------------------------
      if (adjustments.item_characteristic_adj_reasons !== '') {
        this.appendReasonEntries(
          clearList,
          'Characteristic Adjs',
          adjustments.item_characteristic_adj_reasons,
        )
      }
      //---------------------------
      // add entry if ability adjs
      //---------------------------
      if (adjustments.item_ability_adj_reasons !== '') {
        this.appendReasonEntries(
          clearList,
          'Ability Adjs',
          adjustments.item_ability_adj_reasons,
        )
      }
      //-----------------------------------
      // add entry if skill (applied) adjs
      //-----------------------------------
      if (adjustments.item_skill_adj_reasons_applied !== '') {
        this.appendReasonEntries(
          clearList,
          'Skill (Applied) Adjs',
          adjustments.item_skill_adj_reasons_applied,
        )
      }
      //------------------------------------
      // add entry if skill (optional) adjs
      //------------------------------------
      if (adjustments.item_skill_adj_reasons_optional !== '') {
        this.appendReasonEntries(
          clearList,
          'Skill (Optional) Adjs',
          adjustments.item_skill_adj_reasons_optional,
        )
      }
      return clearList
    },
    //================================================================================
    // cancel
    //--------
    _cancel() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({ cancel: true })
      }
    },
    //================================================================================
    // confirm
    //---------
    _confirm() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({ cancel: false })
      }
    },
  },
  //=====================================================================
  // computed
  //----------
  computed: {},
}
</script>

<style scoped>
/* scrollable list styled like a v-select dropdown menu inside a floating field */
.form-floating > .form-control.clearList-dialog-select {
  height: auto;
  /* override default form-floating height */
  min-height: 5rem;
  height: 19rem;
  /* mimic .v-select .vs__dropdown-menu styling */
  margin-top: 10px;
  box-shadow: 0px 0px 1px 1px #737373;
  border-radius: 5px;
  padding-bottom: 1.5rem;
  text-transform: capitalize;
}

.clearList-item + .clearList-item {
  padding-top: 0.8rem;
}

/* reduce counter label font-size only inside this dialog */
::v-deep(.text-center.col-auto .bb-float-label) {
  font-size: 0.8em;
}
</style>
